import { render } from "./Realtor.vue?vue&type=template&id=055e3b38&scoped=true"
import script from "./Realtor.vue?vue&type=script&lang=js"
export * from "./Realtor.vue?vue&type=script&lang=js"

import "./Realtor.vue?vue&type=style&index=0&id=055e3b38&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055e3b38"]])

export default __exports__